export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'risk-warning',
    name: '风险警示',
    description: '揭示不良视频平台的法律风险、隐私泄露隐患及平台封禁政策，帮助用户认清非法内容的严重后果。',
    icon: 'ri-alert-fill',
    color: 'primary',
    articleCount: 12,
  },
  {
    slug: 'healthy-alternative',
    name: '健康替代',
    description: '推荐合规、安全、高质量的正规短视频和娱乐平台，提供丰富多彩的数字娱乐选择。',
    icon: 'ri-heart-pulse-line',
    color: 'accent',
    articleCount: 10,
  },
  {
    slug: 'legal-compliance',
    name: '法律合规',
    description: '解读中国网络内容安全相关法律法规，帮助用户了解合规视频平台的资质要求和运营标准。',
    icon: 'ri-scales-3-line',
    color: 'secondary',
    articleCount: 8,
  },
  {
    slug: 'youth-protection',
    name: '青少年保护',
    description: '聚焦青少年网络安全教育，提供家长监护指南和未成年人健康上网方案。',
    icon: 'ri-shield-user-line',
    color: 'primary',
    articleCount: 9,
  },
];